import { SuperComponent, wxComponent } from '../common/src/index';
import config from '../common/config';
import props from './props';
import { styles, addUnit, getRect } from '../common/utils';

const { prefix } = config;
const name = `${prefix}-icon`;

@wxComponent()
export default class Icon extends SuperComponent {
  externalClasses = [`${prefix}-class`];

  properties = props;

  data = {
    componentPrefix: prefix,
    classPrefix: name,
    isImage: false,
    iconStyle: undefined,
  };

  observers = {
    'name, color, size, style'() {
      this.setIconStyle();
    },
  };

  methods = {
    onTap(event: any) {
      this.triggerEvent('click', event.detail);
    },

    setIconStyle() {
      const { name, color, size, classPrefix } = this.data;
      const isImage = name.indexOf('/') !== -1;

      const sizeValue = size !== null && size !== '' ? addUnit(size) : undefined;
      const colorStyle = color ? { color: color } : {};
      const fontStyle = size ? { 'font-size': sizeValue } : {};
      const iconStyle: Record<string, any> = { ...colorStyle, ...fontStyle };

      this.setData({ isImage }, async () => {
        if (isImage) {
          let iconSize = sizeValue;
          if (!iconSize) {
            await getRect(this, `.${classPrefix}`)
              .then((res) => {
                iconSize = addUnit(res?.height);
              })
              .catch(() => {});
          }

          iconStyle.width = iconSize;
          iconStyle.height = iconSize;
        }
        this.setData({ iconStyle: `${styles(iconStyle)}` });
      });
    },
  };
}
